var divider_viewer_rtlignore_default = {
  "divider-container": "zqLkC",
  "divider-container--double": "vGb3t",
  "divider": "oifVo",
  "divider--single": "O-Hss",
  "divider--double": "ExoEo",
  "divider--dashed": "RSj-g",
  "divider--dotted": "bRtaa",
  "divider--small": "dahuu",
  "divider--small--mobile": "ixgVG",
  "divider--medium": "_5soD6",
  "divider--large--mobile": "pGW1m",
  "divider--medium--mobile": "nntHG",
  "divider--large": "_29QVL",
  "divider--left": "_5-inp",
  "divider--center": "zsle7",
  "divider--right": "IlT8u",
  "divider--fill-parent": "RuXPO",
  "svgFixerContainer": "t6yBE",
  "emptyChar": "crgYO"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
